export default "__VITE_ASSET__mzzbRYKP__"